// Import-free so node --test can load it: the repository that uses this pulls in the axios clients.
// The IZTeach gateway does Base64.decode(password) before comparing, so a raw password never matches.

/** Base64, UTF-8 safe. btoa alone throws InvalidCharacterError on a Vietnamese password. */
export function encodePassword(password: string): string {
  return btoa(unescape(encodeURIComponent(password)));
}
